import {
	EmailToolMergeFields,
	UtmParameters,
	OUTFUNNEL_EMAIL_PARAM
} from '../constants';

/**
 * @constant {String}
 * */
const MERGE_FIELD_PLACEHOLDER = 'MERGE_FIELD_PLACEHOLDER';

/**
 * @constant {String}
 * */
const HTTP_SCHEME = 'http://';

/**
 * @constant {String}
 * */
const HTTPS_SCHEME = 'https://';

/**
 * @param {String} emailTool
 * @return {String}
 * */
const getMergeField	 = emailTool => {
	const mergeField = EmailToolMergeFields[emailTool];

	if (!mergeField) {
		return '';
	}

	return mergeField;
};

/**
 * @param {String} url
 * @param {String} utm
 * @return {Boolean}
 */
const hasUtmInUrl = (url, utm) => url.includes(utm);

/**
 * @param {String} url
 * @return {Boolean}
 */
const hasHttpInUrl = url => url.includes(HTTP_SCHEME) || url.includes(HTTPS_SCHEME);

/**
 * @param {String} urlString
 * @return {Boolean}
 */
const isValidUrl = urlString => {
	try {
		return Boolean(new URL(urlString));
	} catch (err) {
		return false;
	}
};

/**
 * @class
 * */
export default class ComposedUrl {
	/**
	 * @param {String} emailTool
	 * @param {String} url
	 * */
	constructor(emailTool, url) {
		this.url = null;
		this.setUrl(url);

		this.emailTool = emailTool;
		this.newUrl = null;

		this.buildUrl();
	}

	/**
	 * @param {String} url
	 * @return {void}
	 * */
	setUrl(url) {
		if (!hasHttpInUrl(url)) {
			this.url = `${HTTPS_SCHEME}${url}`;

			return;
		}

		this.url = url;
	}

	/**
	 * @return {void}
	 * */
	buildUrl() {
		if (!isValidUrl(this.url)) {
			return;
		}

		this.newUrl = new URL(this.url);
		if (!hasUtmInUrl(this.url, UtmParameters.UTM_SOURCE)) {
			this.addSourceUtm();
		}

		if (!hasUtmInUrl(this.url, UtmParameters.UTM_MEDIUM)) {
			this.addMediumUtm();
		}

		this.addMergeField();
	}

	/**
	 * @return {void}
	 * */
	addSourceUtm() {
		this.newUrl.searchParams.append(UtmParameters.UTM_SOURCE, this.emailTool);
	}

	/**
	 * @return {void}
	 * */
	addMediumUtm() {
		this.newUrl.searchParams.append(UtmParameters.UTM_MEDIUM, 'email');
	}

	/**
	 * @return {void}
	 * */
	addMergeField() {
		this.newUrl.searchParams.append(OUTFUNNEL_EMAIL_PARAM, MERGE_FIELD_PLACEHOLDER);
	}

	/**
	 * @return {String|null}
	 * */
	getNewUrl() {
		if (!this.newUrl) {
			return '';
		}

		return this.newUrl.href.replace(
			MERGE_FIELD_PLACEHOLDER, getMergeField(this.emailTool)
		);
	}
}
